let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jnGGh")).then(() => parcelRequire('kS58d'));